import React from 'react';
import CustomDatasetAction from '../containers/CustomDatasetAction';

const CustomDatasetActions = ({ actions }) => (
  actions.map((action) => (
    <CustomDatasetAction
      key={`custom_dataset_action_item_${action.url}`}
      label={action.label}
      description={action.description}
      url={action.url}
      target={action.target}
      disabled={action.decode_errors.length > 0}
    />
  ))
);

export default CustomDatasetActions;
